import { render, staticRenderFns } from "./LocationDetails.template.vue?vue&type=template&id=2f4860db&scoped=true&"
var script = {}
import style0 from "./LocationDetails.template.vue?vue&type=style&index=0&id=2f4860db&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4860db",
  null
  
)

export default component.exports